import { createFileRoute } from '@tanstack/react-router';

import { validateMailSearch } from '../../../features/webmail/lib/search-params.ts';
import { WebmailPage } from '../../../features/webmail/webmail-page.tsx';
import { requirePermissionRoute } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/mail/')({
  validateSearch: validateMailSearch,
  beforeLoad: requirePermissionRoute('mail.use'),
  component: AllInboxes,
});

function AllInboxes() {
  return <WebmailPage mailboxId={null} folder={null} search={Route.useSearch()} />;
}
